// src/utils/menu.js

/**
 * Obtiene la información del restaurante y mesa desde localStorage
 * @returns {Object} Objeto con la información del restaurante y mesa
 */
export const getTableInfo = () => {
  
  try {
    console.log("[menu.js] getTableInfo:", localStorage.getItem("tableInfo"));
    const tableInfo = localStorage.getItem("tableInfo");
    console.log("[menu.js] Raw tableInfo from localStorage:", tableInfo);

    if (!tableInfo) {
      console.warn("[menu.js] No tableInfo found in localStorage");
      return null;
    }

    const parsedInfo = JSON.parse(tableInfo);
    console.log("[menu.js] Parsed tableInfo:", parsedInfo);
    return parsedInfo;
  } catch (error) {
    console.error("[menu.js] Error parsing table info:", error);
    return null;
  }
};

/**
 * Construye la URL del menú con los parámetros necesarios
 * @returns {string} URL completa del menú
 */
export const getMenuUrl = () => {
  const tableInfo = getTableInfo();

  // Si no hay información de la mesa, intentar obtener los parámetros de la URL actual
  // if (!tableInfo?.restoId || !tableInfo?.mesaId) {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const param1 = urlParams.get("param1");
  //   const param2 = urlParams.get("param2");

  //   if (param1 && param2) {
  //     return `/?param1=${param1}&param2=${param2}`;
  //   }

  //   console.warn("[menu.js] Missing required table information");
  //   return "/";
  // }

  return `/?param1=${tableInfo.restoId}&param2=${tableInfo.mesaId}`;
};

/**
 * Valida si existe una sesión de mesa válida
 * @returns {boolean} true si la sesión es válida, false en caso contrario
 */
export const hasValidTableSession = () => {
  console.log("Menu.js ", localStorage.getItem("mesaId"))
  try {
    const mesaId = localStorage.getItem("mesaId");

    const tableInfo = getTableInfo();
    console.log("[menu.js] Validating session - tableInfo:", tableInfo);

    // Validar que existan todos los datos necesarios
    // if (!mesaId || !tableInfo || !tableInfo.restoId || !tableInfo.mesaId) {
    //   console.warn("[menu.js] Invalid session - missing required data");
    //   return false;
    // }

    // // Validar que los IDs coincidan
    // if (mesaId !== tableInfo.mesaId) {
    //   console.warn("[menu.js] Invalid session - mesaId mismatch");
    //   return false;
    // }

    return true;
  } catch (error) {
    console.error("[menu.js] Error validating session:", error);
    return false;
  }
};

/**
 * Guarda la información de la mesa en localStorage
 * @param {Object} tableData Datos de la mesa a guardar
 */
export const saveTableInfo = (tableData) => {
  try {
    if (!tableData) {
      console.warn("[menu.js] Attempting to save invalid table data");
      return;
    }

    localStorage.setItem("tableInfo", JSON.stringify(tableData));
    localStorage.setItem("mesaId", tableData.mesaId);
    console.log("[menu.js] Table info saved successfully");
  } catch (error) {
    console.error("[menu.js] Error saving table info:", error);
  }
};
